import { ResponsiveSection } from '@stitch-fix/mode-react';
import type { GetServerSideProps, NextPage } from 'next';
import { Layout } from '../../components/Layout';
import { OneTrustContent } from '../../components/OneTrustContent/OneTrustContent';
import { SEOData } from '../../components/SEOData';
import { privacyData } from './data';

interface PrivacyPageProps {
  documentId: string;
  canonicalUrl: string;
}

const PrivacyPage: NextPage<PrivacyPageProps> = ({
  documentId,
  canonicalUrl,
}) => {
  return (
    <Layout viewEventTrackingName="corporate">
      <SEOData
        title="Privacy Policy | Stitch Fix"
        canonicalUrl={canonicalUrl}
      />
      <ResponsiveSection
        as="main"
        // setting this id allows the "Skip to page content" link to render from knit
        id="knit-main-content"
        mt="0"
        width={{ sm: 'full-bleed' }}
        gutter="none"
      >
        <OneTrustContent documentID={documentId} />
      </ResponsiveSection>
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps<PrivacyPageProps> = async ({
  req,
}) => {
  // Check if request is from UK domain
  const isUK =
    req.headers.host === 'www.stitchfix.co.uk' ||
    process.env.NEXT_PUBLIC_REGION === 'UK';

  const region = isUK ? 'UK' : 'US';
  const { documentId, seoData } = privacyData[region];
  const canonicalUrl =
    seoData.canonicalUrl || 'https://www.stitchfix.com/privacy';

  return {
    props: {
      documentId,
      canonicalUrl,
    },
  };
};

export default PrivacyPage;
